<template>
  <div class="footer-warpper">
    <!-- 底部 -->
    <div class="footer-border">
      <div class="footer-left">
        <p class="logo-font-box">
          <img
            class="w280"
            src="../../assets/images/20.png"
            alt=""
            srcset=""
          />
          <!-- <span class="logo-font">意约科技</span> -->
        </p>
        <p class="footer-left-font">让手艺人成为受人尊重的自由职业者</p>

        <div class="footer-scan-code">
          <div>
            <img
              src="../../assets/images/scanwx.png"
              alt=""
              srcset=""
            />
            <p class="line1" title="意约小程序-用户端">意约小程序-用户端</p>
          </div>
          <div>
            <img
              width="100%"
              style="border-radius: 5px"
              src="../../assets/images/wxmfs.png"
              alt=""
              srcset=""
            />
            <p class="line1" title="意约小程序-美发师端">意约小程序-美发师端</p>
          </div>
          <div>
            <img
              width="100%"
              style="border-radius: 5px"
              src="../../assets/images/wxmdd.png"
              alt=""
              srcset=""
            />
            <p class="line1" title="意约小程序-门店端">意约小程序-门店端</p>
          </div>
        </div>
      </div>
      <div class="footer-right">

        <el-row class="footer-right-main">
       
          <el-col :span="6">
            <p class="footer-right-main-font">解决方案</p>
            <p class="footer-right-link-text">
              <router-link to="/">美业综合店</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">美发专业店</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">美发工作室</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">大健康</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">美容院</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">医疗美容院</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">更多...</router-link>
            </p>
          </el-col>
          <el-col :span="6">
            <p class="footer-right-main-font">关于意约</p>
            <p class="footer-right-link-text">
              <router-link to="/">意约介绍</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">企业文化</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">合作联系</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">新闻中心</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">招商中心</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">管理团队</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">更多...</router-link>
            </p>
          </el-col>
          <el-col :span="6">
            <p class="footer-right-main-font">关于荣誉</p>
            <p class="footer-right-link-text">
              <router-link to="/">纳斯达克美业数字化第一股</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">中美协优秀企业家</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">中美协战略合作单位</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="">中国AAA级信誉企业</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">深圳科技型中小企业</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">广西慈善总会爱心企业</router-link>
            </p>
            <p class="footer-right-link-text">
              <router-link to="/">更多...</router-link>
            </p>
          </el-col>
          <el-col :span="6">
            <p class="footer-right-main-font">申请体验</p>
            <p class="footer-right-link-text">
              <router-link to="/">第一时间为你提供服务支持</router-link>
            </p>
            <!-- <p class="footer-right-link-text"> -->
              <div style="display: flex;">
                <el-input placeholder="请输入您的手机号码" v-model="input2"></el-input>
                <span class="phone-bnt">></span>
              </div>
            <!-- </p> -->
            <p>
              <div class="footer-right-ph">热线服务</div>
              <div class="footer-right-ph-d footerbut">400-6866-227</div>
            </p>
            <p>
              <div class="footer-right-ph">技术服务热线</div>
              <div class="footer-right-ph-d">400-6866-227/转01</div>
            </p>
          </el-col>
        </el-row>

        <!-- <p class="footer-links-text">
          LINKS：
          <a href="https://www.baidu.com" target="_blank" rel="noopener noreferrer">百度</a> ｜
          <a href="https://www.google.cn" target="_blank" rel="noopener noreferrer">谷歌</a> ｜
          <a href="https://www.zhihu.com" target="_blank" rel="noopener noreferrer">知乎</a> ｜
          <a href="https://www.1688.com" target="_blank" rel="noopener noreferrer">阿里巴巴</a> ｜
          <a href="https://www.jd.com" target="_blank" rel="noopener noreferrer">京东</a> ｜
          <a href="https://www.taobao.com" target="_blank" rel="noopener noreferrer">淘宝</a> ｜
          <a href="https://www.qq.com" target="_blank" rel="noopener noreferrer">腾讯</a>
        </p> -->
      </div>
    </div>

    <div class="footer-copyright">
      <div 
        ><img src="../../assets/images/39.png" />Copyright ©2017-2022 深圳市意约数字科技有限公司
        粤ICP备19011453号-2</div
      >
      <div style="color: #fff;">深圳总部中心：深圳市南山区粤海街道高新区社区高新南九道45号西北工业大学三航科技大厦2405</div
      >
    </div>


  </div>
</template>

<script>
import api from "../../api/website";
export default {
  data() {
    var validatorPhone = function (rule, value, callback) {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      input2:'',
      formData: {},
      formData2: {},
      dialogVisible: false,
      dialogVisible2: false,
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        content: [{ required: true, message: "请输入留言", trigger: "blur" }],
        mobile: [
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
      },
      rules2: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        mobile: [
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    tipsText() {
      this.$message("即将开通，尽请期待。");
    },
    handleClose() {
      this.dialogVisible = false;
      this.formData = {};
    },
    handleClose2() {
      this.dialogVisible2 = false;
      this.formData2 = {};
    },
    onlineConsultation() {},
    leavingMessage() {
      this.dialogVisible = true;
    },
    submitData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          api
            .addLeavingMsg({
              ...this.formData,
            })
            .then((res) => {
              if (res.code == "00000") {
                this.$message("留言成功！");
                this.dialogVisible = false;
                this.formData = {};
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitData2() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          api
            .addComplaints({
              ...this.formData2,
            })
            .then((res) => {
              if (res.code == "00000") {
                this.$message("提交成功！");
                this.dialogVisible2 = false;
                this.formData2 = {};
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.footer-warpper {
  width: 100%;
  box-sizing: border-box;
  padding: 70px 0 20px 0;
  background: #1f1f1f;
}
.logo-font-box {
  display: flex;
  align-items: center;
  & .logo-font {
    font-size: 32px;
    font-family: ZhenyanGB;
    color: #ffffff;
    margin-left: 16px;
  }
}
.footer-left-font {
  height: 24px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #EB5C20;
  line-height: 24px;
  margin-top: 19px;
}
.footer-left-font2 {
  line-height: 20px;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  margin-top: 46px;
}
.footer-border {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  padding-bottom: 15px;
  border-bottom: 1px solid #677277;
}
.footer-scan-code {
  width: 100%;
  margin-top: 36px;
  & > div {
    width: 94px;
    float: left;
    & > p {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #fff;
      margin-top: 15px;
    }
    &>img{
      width: 86px;
      border-radius: 6px;
    }
  }
  & > div:not(:first-child) {
    margin-left: 8px;
  }
}
.footer-left {
  width: 310px;
  border-right: 1px solid #666666;
}
.footer-right {
  flex: 1;
  margin-left: 25px;

  & .footer-right-text {
    height: 20px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    text-align: right;
  }
  & .footer-right-text2 {
    line-height: 28px;
    height: 28px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ff9447;
    margin-top: 26px;
    text-align: right;
    & > i {
      width: 31px;
      height: 28px;
      display: block;
      background: url("../../assets/images/phoneicon.png") 100% 100%;
      background-size: 31px 28px;
      float: right;
    }
    & > span {
      float: right;
      margin-left: 11px;
    }
    // display:flex;
    // justify-content:flex-end;
    // align-items:center;
  }

  & .footer-right-main {
    margin-top: 11px;

    & .footer-right-main-font {
      color: #fff;
      font-weight: 500;
      font-size: 12px;
      margin-bottom: 32px;
      font-family: SourceHanSansCN, SourceHanSansCN;
    }
  }
  .footer-right-link-text {
    margin-top: 20px;
    color: #999999;
    cursor: pointer;
    font-size: 12px;
    padding-right: 8px;
    a{
      color: #999999;
    }
  }
  // .footer-right-link-text:hover,
  // .footer-right-link-text:hover a {
  //   color: #ff9447;
  // }
  .footer-links-text {
    color: #999999;
    font-size: 16px;
    margin-top: 23px;
  }
}
.footer-copyright {
  font-size: 10px;
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  color: #999999;
  display: flex;
  align-items: center;
  height: 22px;
  justify-content: space-between;
  img{
    width: 18px;
    height: 20px;
    vertical-align: middle;
    margin-right: 10px;
    margin-top: -6px;
  }
}
.flex-align-items {
  display: flex;
  align-items: center;
}

/deep/ .el-dialog__header {
  background: #ff9447;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  text-align: center;
}
/deep/ .el-dialog__title {
  color: #fff;
}
/deep/ .el-dialog {
  border-radius: 5px;
}
.ml128 {
  margin-left: 128px;
}
.w49 {
  width: 49px;
}
.w27 {
  width: 27px;
}
.footer-right-ph{
  font-size: 16px;
  color: #fff;
  font-weight: 600;
}
.footer-right-ph-d{
  font-size: 18px;
  color: #999999;
  margin-top: 2px;
  font-weight: 500;
}
.footerbut{
  margin-bottom: 14px;
}
/deep/ input{
  background: rgba(0, 0, 0, 0);
  margin-bottom: 30px;
  border-radius: 0!important;
  border: 1px solid #666;
  height: 30px;
  margin-top: 10px;
}
.phone-bnt{
  width: 42px;
  height: 30px;
  line-height: 30px;
  background: #FF6A06;
  color: #fff;
  cursor: pointer;
  text-align: center;
  border: 1px solid #FF6A06;
  font-size: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}
.w280{
  width: 286px;
  height: 70px;
}
/deep/ input::placeholder {
  color: #999;
  font-size: 14px;
}
</style>